import { jsx as _jsx, jsxs as _jsxs } from "nativewind/jsx-runtime";
import React from 'react';
import { ScrollView, View } from 'react-native';
import { ScreenLayout } from '@/components/ScreenLayout';
import ConquererSummarySection from './sections/ConquererSummarySection';
import CrusherHistorySection from './sections/CrusherHistorySection';
import WeeklyConquererSection from './sections/WeeklyConquererSection';
export default function ConquererScreen({}) {
    return (_jsx(ScreenLayout, { isHeaderVisible: true, children: _jsxs(ScrollView, { contentContainerStyle: { flexGrow: 1 }, style: { backgroundColor: 'white' }, children: [_jsx(ConquererSummarySection, {}), _jsx(WeeklyConquererSection, {}), _jsx(View, { className: "h-[10px] bg-gray-10" }), _jsx(CrusherHistorySection, {}), _jsx(View, { style: { height: 60 } })] }) }));
}
